export default __webpack_public_path__ + "static/media/120.aea43c1b.svg";